import { Box, Flex } from "@chakra-ui/react";
import {
  COLORS_COMPETATIVE_METRICS,
  TYPES_OF_COMPETATIVE_METRICS,
} from "../../constants/metrics";
import downarrowmenu from "../../assets/images/arrow-down.png";
import uparrowmenu from "../../assets/images/arrow-up.png";
import sales from "../../assets/images/sales.png";
import distribution from "../../assets/images/distribution.png";
import hr from "../../assets/images/hr.png";
import production from "../../assets/images/production.png";
import operation from "../../assets/images/operation.png";
import financing from "../../assets/images/financing.png";
import { useEffect, useState } from "react";

export const CompetitiveTabs = ({
  setCurrentCompetativeMetric,
  currentCompetativeMetric,
  currentMetric,
  setCurrentMetric,
  metricColors,
  setCompetitiveMenuLabel,
  competitiveMenuObjects,
  setCompetitiveMenuObjects,
}) => {  
  const imageObject = {
    Sales: sales,
    Distribution: distribution,
    HR: hr,
    Production: production,
    Operations: operation,
    Finance: financing,
  };
  console.log(
    "====currentCompetativeMetric",
    currentCompetativeMetric,
    currentMetric,
    competitiveMenuObjects
  );
  useEffect(() => {
    const result = {};
    const labelMap = {};
    TYPES_OF_COMPETATIVE_METRICS.forEach((category) => {
      const categoryName = category.label;
      result[categoryName] = [];

      category.value.forEach((subCategory) => {
        subCategory.value.forEach((metric) => {
          result[categoryName].push(metric.value);
          labelMap[metric.value] = metric.label;
        });
      });
    });
    setCompetitiveMenuObjects(result);
    setCompetitiveMenuLabel(labelMap);
  }, []);
  return (
    <Box id={"segment_risks_type"} className="leftNavOptions">
      {TYPES_OF_COMPETATIVE_METRICS?.map((data) => (
        <Box
          m={"0px"}
          w={"100%"}
          style={{
            border: "1.3px solid var(--sylvr-text-color-selected)",
            backgroundColor: "#F2F7F7",
            borderRadius: "4px",
            padding: "8px",
            marginBottom: "15px",
          }}
        >
          <Box>
            <Flex
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                paddingBottom: "5px",
              }}
              onClick={() => {
                setCurrentCompetativeMetric(data?.label);
                setCurrentMetric(competitiveMenuObjects[data?.label][0]);
              }}
            >
              <Box
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  textAlign: "left",
                }}
              >
                {data?.label}
              </Box>
              <Box className="menu-icon">
                <img
                  src={
                    currentCompetativeMetric === data?.label
                      ? uparrowmenu
                      : downarrowmenu
                  }
                  alt="menu-arrow"
                  className="metric-arrow"
                />
              </Box>
            </Flex>
          </Box>
          {currentCompetativeMetric === data?.label &&
            data?.value?.map((value, indexV1) => (
              <Box
                m={"0px"}
                w={"100%"}
                style={{
                  backgroundColor: "var(--sylvr-text-color-selected)",
                  borderRadius: "4px",
                  marginBottom: "10px",
                }}
                key={`${value?.label}-${indexV1}`}
              >
                <Flex justifyContent={"flex-start"} alignItems={"center"}>
                  <Box style={{ marginLeft: "9px" }}>
                    <img src={imageObject[value?.label]} />
                  </Box>
                  <Box className="sylvr-subtitle-menu">{value?.label}</Box>
                </Flex>
                {value?.value?.map((row, index) => (
                  <>
                    <Box
                      className={
                        index === value?.value?.length - 1
                          ? "sylvr-subtitle-menu-card metric-bottomBorderRadius"
                          : "sylvr-subtitle-menu-card"
                      }
                    >
                      <Box
                        className="sylvr-subtitle-label"
                        backgroundColor={
                          currentMetric === row?.value
                            ? metricColors[currentMetric]?.bgColor
                            : COLORS_COMPETATIVE_METRICS[row?.value]?.unselected
                                ?.bgColor
                        }
                        color={
                          currentMetric === row?.value
                            ? metricColors[currentMetric]?.textColor
                            : COLORS_COMPETATIVE_METRICS[row?.value]?.unselected
                                ?.textColor
                        }
                        cursor="pointer"
                        onClick={() => {
                          setCurrentMetric(row?.value);
                        }}
                      >
                        {row?.label}
                      </Box>
                    </Box>
                    {index !== value?.value?.length - 1 && (
                      <Box
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <Box
                          style={{
                            border: "1.5px solid #E6E6E6",
                            margin: "0px 5px",
                          }}
                        ></Box>
                      </Box>
                    )}
                  </>
                ))}
              </Box>
            ))}
        </Box>
      ))}
    </Box>
  );
};
